import { ViewId } from '~/shared/utils';
import { useIntl } from 'react-intl';
import { CaptionButton } from '~/shared/components/ui/Button';
import { GetMessageWithIntl } from '~/shared/components';
import { getGenerallyIconElement } from '~/shared/components/parts/Button/GenerallyIcons';

import { Textarea } from '~/shared/components/ui';

interface EditPanelItemProps {
  companyInfo?: string;
  evaluationIndex1?: string;
  evaluationIndex2?: string;
  evaluationIndex3?: string;
  evaluationIndex4?: string;
  onCompanyInfoChange?: (value: string) => void;
  onEvaluationIndex1Change?: (value: string) => void;
  onEvaluationIndex2Change?: (value: string) => void;
  onEvaluationIndex3Change?: (value: string) => void;
  onEvaluationIndex4Change?: (value: string) => void;
}

interface EditPanelFooterProps {
  onBack: () => void;
  onTempSave: () => void;
}

const VIEW_ID: ViewId = 'OCP_PR_INPUT';
export const EditPanelItem = ({
  companyInfo = '',
  evaluationIndex1 = '',
  evaluationIndex2 = '',
  evaluationIndex3 = '',
  evaluationIndex4 = '',
  onCompanyInfoChange,
  onEvaluationIndex1Change,
  onEvaluationIndex2Change,
  onEvaluationIndex3Change,
  onEvaluationIndex4Change,
}: EditPanelItemProps) => {
  return (
    <>
      <div className="tab-info-body">
        <div className="description-area">
          <p className="title">
            {getGenerallyIconElement('unchecked')}
            編集
          </p>
          <p className="text-box">
            <span className="text">
              手動で修正します。
              <br />
              この画面では公開登録は行いません。一時保存を行い、次の画面で公開前の最終確認を行います。
            </span>
          </p>
        </div>
        <div className="expandable-container-area">
          <div className="container-title">企業紹介</div>
          <div>
            <Textarea
              name="prompt"
              className="container-textarea"
              value={companyInfo}
              columns={['prompt']}
              onChangeState={(v) => onCompanyInfoChange?.(v)}
              isNoErrorMessage={true}
            />
          </div>
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">得意な生産形態</div>
            <div>
              <Textarea
                name="prompt"
                className="container-textarea"
                value={evaluationIndex1}
                columns={['prompt']}
                onChangeState={(v) => onEvaluationIndex1Change?.(v)}
                isNoErrorMessage={true}
              />
            </div>
          </div>
          <div className="description-container">
            <div className="container-title">品質保証・検査</div>
            <div>
              <Textarea
                name="prompt"
                className="container-textarea"
                value={evaluationIndex2}
                columns={['prompt']}
                onChangeState={(v) => onEvaluationIndex2Change?.(v)}
                isNoErrorMessage={true}
              />
            </div>
          </div>
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">主要取引業界</div>
            <div>
              <Textarea
                name="prompt"
                className="container-textarea"
                value={evaluationIndex3}
                columns={['prompt']}
                onChangeState={(v) => onEvaluationIndex3Change?.(v)}
                isNoErrorMessage={true}
              />
            </div>
          </div>
          <div className="description-container">
            <div className="container-title">技術・設備のポイント</div>
            <div>
              <Textarea
                name="prompt"
                className="container-textarea"
                value={evaluationIndex4}
                columns={['prompt']}
                onChangeState={(v) => onEvaluationIndex4Change?.(v)}
                isNoErrorMessage={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const EditPanelFooterItem = ({
  onBack: onBack,
  onTempSave: onTempSave,
}: EditPanelFooterProps) => {
  const intl = useIntl();
  return (
    <>
      <CaptionButton
        name="resetBtn"
        caption={GetMessageWithIntl(intl, { id: 'return' })}
        className="btn"
        onClick={onBack}
        buttonType="basic"
      />
      <CaptionButton
        name="resetBtn"
        caption={GetMessageWithIntl(intl, {
          prefixId: VIEW_ID,
          id: 'nextTempSave',
        })}
        className="btn"
        onClick={onTempSave}
        buttonType="basic"
      />
    </>
  );
};
